import {all, delay, fork, put, takeLatest} from "redux-saga/effects";
import AlgoliaService from "../../services/AlgoliaService";
import {
  createServiceSuccess,
  deleteServiceSuccess,
  getServicesSuccess,
  getServiceSuccess,
  setLoadingInvisible,
  setLoadingVisible,
  updateServiceSuccess
} from "../actions";
import {CREATE_SERVICE, DELETE_SERVICE, GET_SERVICE, GET_SERVICES, UPDATE_SERVICE} from "../constants/Services";
import EstService from "../../services/EstService";

export function* getServices(){
  yield takeLatest(GET_SERVICES, function* ({page, perPage, search}){
    try {
      if(search && page === 1)
        yield delay(1000)

      const res = yield AlgoliaService.getServices({
        query: search,
        hitsPerPage: perPage,
        page: (page - 1)
      })

      const skip = perPage * (page - 1)
      const from = skip + 1
      const to = (skip + perPage > res.data.nbHits) ? res.data.nbHits : skip + perPage
      yield put(getServicesSuccess(res.data.hits, res.data.nbHits, from, to))
    } catch (err){
      console.log(err)
    }
  })
}

export function* createService(){
  yield takeLatest(CREATE_SERVICE, function* ({data, history}){
    try {
      //put service numbers into string array
      let service_numbers = []
      for(let i = 1; i <= 5; i++){
        if(data[`service_number_${i}`]){
          service_numbers.push(data[`service_number_${i}`])
          delete data[`service_number_${i}`]
        }
      }
      data = {
        ...data,
        service_numbers
      }
      const res = yield EstService.createService(data)
      yield put(createServiceSuccess(res.data))
      history.push(`/app/services/${res.data.account_service_id}`)
    } catch (err){
      console.log(err)
    }
  })
}

export function* updateService(){
  yield takeLatest(UPDATE_SERVICE, function* ({id, service, history}){
    try {
      //put service numbers into string array
      let service_numbers = []
      for(let i = 1; i <= 5; i++){
        if(service[`service_number_${i}`]){
          service_numbers.push(service[`service_number_${i}`])
          delete service[`service_number_${i}`]
        }
      }
      service = {
        ...service,
        service_numbers
      }
      const res = yield EstService.updateService(id, service)
      yield put(updateServiceSuccess(res.data))
      history.push(`/app/services/${res.data.account_service_id}`)
    } catch (err){
      console.log('err')
      console.log(err)
    }
  })
}

export function* getService(){
  yield takeLatest(GET_SERVICE, function* ({id}){
    try {
      const res = yield EstService.getService(id)

      yield put(getServiceSuccess(res.data))
    } catch (err){
      console.log(err)
    }
  })
}

export function* deleteService(){
  yield takeLatest(DELETE_SERVICE, function* ({service_id, history}){
    try {
      yield put(setLoadingVisible());
      yield EstService.deleteService(service_id);

      yield delay(1500);
      yield put(deleteServiceSuccess(service_id));
      yield put(setLoadingInvisible());
      history.push('/app/services');
    } catch (err){
      console.log(err);
      yield put(setLoadingInvisible());
    }
  })
}

export default function* servicesSaga() {
  yield all([
    fork(getServices),
    fork(createService),
    fork(getService),
    fork(updateService),
    fork(deleteService),
  ]);
}